<mat-card>
  <app-card-header
    [title]="tituloActual"
    [subtitle]="data.luminaria?.identificacion || ''"
    icono="show_chart"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear gexp-contenido">
    <!-- Tabs de navegación entre métricas -->
    <nav
      mat-tab-nav-bar
      [tabPanel]="tabPanel"
      color="primary"
      class="tabs-metricas"
    >
      @for (key of allKeys; track key) {
        <a
          mat-tab-link
          [active]="selectedKey === key"
          [disabled]="cargando"
          (click)="cambiarKey(key)"
        >
          {{ allSeriesNames[key] }}
        </a>
      }
    </nav>
    <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>

    <!-- Controles: rango de fechas + escala -->
    <div class="controles-container">
      <app-date-picker
        mode="daterange"
        [requireConfirm]="true"
        label="Rango de fechas"
        [maxDate]="hoy"
        [(ngModel)]="rango"
        (ngModelChange)="onRangoChange($event)"
      ></app-date-picker>

      <div class="max-ejeY-container">
        <mat-form-field appearance="outline" class="max-ejeY-field">
          <mat-label>Máximo eje Y</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="maxEjeY"
            (keydown.enter)="aplicarMaxEjeY()"
            placeholder="Auto"
          />
        </mat-form-field>
        <button irxBotonIcono (click)="aplicarMaxEjeY()" tooltip="Aplicar">
          <mat-icon>check</mat-icon>
        </button>
        @if (maxEjeY !== null) {
          <button
            irxBotonIcono
            (click)="maxEjeY = null; aplicarMaxEjeY()"
            tooltip="Restablecer"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </div>

    <!-- Loading -->
    @if (cargando) {
      <div class="estado-grafico">
        <mat-spinner diameter="48"></mat-spinner>
        <p>Cargando datos...</p>
      </div>
    }

    <!-- Gráfico -->
    @if (!cargando && chartOptions) {
      <highcharts-chart
        [Highcharts]="Highcharts"
        [options]="chartOptions"
        [update]="updateFlag"
        style="width: 100%; display: block"
      ></highcharts-chart>
    }

    <!-- Sin datos -->
    @if (!cargando && !chartOptions) {
      <div class="estado-grafico">
        <mat-icon class="icono-vacio">bar_chart</mat-icon>
        <p>No hay datos para el rango seleccionado</p>
      </div>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button
      irxBoton="secundario"
      type="button"
      [disabled]="cargando || !reportesCacheados.length"
      (click)="exportarExcel()"
    >
      <mat-icon>file_download</mat-icon>
      Exportar a Excel
    </button>
    <button irxBoton="secundario" type="button" (click)="cerrar()">
      Cerrar
    </button>
  </mat-card-actions>
</mat-card>
